module.exports = __webpack_public_path__ + "static/sample_5-a94b9a3501a0601903a95f3631c21a28.jpg";